import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { toast } from "sonner";
import { MonitorSmartphone } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const withinDays = (iso: string | null | undefined, days: number) => {
  if (!iso) return false;
  const t = Date.parse(iso);
  return !Number.isNaN(t) && Date.now() - t < days * 86400 * 1000;
};

export const CrossDeviceNudge = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { data } = useQuery({
    queryKey: ["jump-back-in"],
    queryFn: async () => (await api.get("/account/jump-back-in")).data,
    enabled: !!user,
    staleTime: 5 * 60 * 1000,
  });

  useEffect(() => {
    if (!data?.resume?.length) return;
    try {
      if (sessionStorage.getItem("nl_xdevice_nudged")) return;
      const myVid = localStorage.getItem("nl_vid");
      if (!myVid) return;
      const cand = data.resume.find((a: any) =>
        a.device_id && a.device_id !== myVid && a.slug &&
        withinDays(a.last_read_at, 7) &&
        !localStorage.getItem(`nl_xd_${a.slug}`));
      if (!cand) return;
      sessionStorage.setItem("nl_xdevice_nudged", "1");
      localStorage.setItem(`nl_xd_${cand.slug}`, "1");
      toast(`Continue on this device`, {
        id: "cross-device-nudge",
        icon: <MonitorSmartphone className="h-4 w-4 text-[#00E5FF]" />,
        description: `You're ${cand.progress_percent}% into “${cand.title}” on another device — pick up right where you left off.`,
        duration: 12000,
        action: {
          label: "Resume",
          onClick: () => navigate(`/article/${cand.slug}?resume=1`),
        },
      });
    } catch { /* storage unavailable */ }
  }, [data, navigate]);

  return null;
};
